import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuthUser from "../../hooks/useAuthUser.js";
import ChatBot from "../../components/ChatBot.jsx";

const TabNavigation = () => {
    const { loggedInUser } = useAuthUser();
    const userRole = Number(loggedInUser?.role);

    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        { name: 'Request', path: '/asset-management/requests' },
        { name: 'Assets', path: '/asset-management/assets' },
    ];

    if ([1, 2, 8, 9].includes(userRole)) {
        tabs.push({ name: 'Setting', path: '/asset-management/setting' });
    }

    // Redirect to the first tab if current path doesn't match any tab path
    useEffect(() => {
        const isValidPath = tabs.some(tab => tab.path === location.pathname);
        if (!isValidPath) {
            navigate(tabs[0].path, { replace: true });
        }
    }, [location.pathname, tabs, navigate]);

    return (
        <div>
            <ul className="nav nav-tabs" role="tablist">
                {tabs.map((tab) => (
                    <li className="nav-item" key={tab.path} role="presentation">
                        <button
                            className={`nav-link ${location.pathname === tab.path ? 'active' : ''}`}
                            onClick={() => navigate(tab.path)}
                        >
                            {tab.name}
                        </button>
                    </li>
                ))}
            </ul>
        {/* <ChatBot /> */}
        </div>
    );
};

export default TabNavigation;
